import { customElement, property } from 'lit/decorators.js';
import { css, LitElement, nothing } from 'lit';
import '@carbon/web-components/es/components/modal/index.js';
import { PropertyValues } from '@lit/reactive-element';
import { googleApi } from './googleApi';
import Debug from 'debug';
import { dataBroker } from '../services/DataBroker';

const log = Debug('pdq:google:PdqGoogleFilelistDatasource');

@customElement('pdq-google-filelist-datasource')
export class PdqGoogleFilelistDatasource extends LitElement {
  @property({ type: String })
  id: string = '';

  @property({ type: String })
  driveId: string = '';

  @property({ type: String })
  parentId: string = '';

  @property({ type: String })
  q: string = '';

  static styles = css``;

  render() {
    return nothing;
  }

  updated(changedProperties: PropertyValues) {
    log('updated');
    this.updateFileAsRequired();
  }

  firstUpdated() {
    log('firstUpdated');
    this.updateFileAsRequired();
  }

  private lastCacheKey = ''
  private async updateFileAsRequired() {
    if(!this.id) {
      log(`not trying to list files due to no id`)
      return
    }
    const cacheKey =  this.driveId + this.parentId + this.q
    if (this.lastCacheKey === cacheKey)
      return
    this.lastCacheKey = cacheKey
    log(`loading file list from google driveId:${this.driveId} parentId:${this.parentId} q=${this.q}`)

    const list = await googleApi.listFiles(this.driveId, this.parentId, this.q);
    dataBroker.setDataSource(this.id, list)

  }
}
